export const hotGossipItems = [
  {
    id: 1,
    name: '张某某',
    title: '知名演员深夜密会神秘女子',
    category: '明星黑料',
    heat: '128.5万',
    summary: '据知情人士透露，该演员在深夜被拍到与神秘女子同回住所，引发粉丝热议。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20stylish%20Chinese%20celebrity%20in%20a%20dark%20moody%20atmosphere%20with%20dramatic%20lighting%2C%20soft%20film%20grain%20texture%2C%20warm%20amber%20spotlights%20from%20above%2C%20mysterious%20and%20glamorous%20vibe%2C%20editorial%20photography%20style%20with%20deep%20shadows%2C%20high%20contrast%20black%20and%20warm%20tones%2C%20simple%20dark%20background%20with%20subtle%20light%20leaks&width=600&height=800&seq=gossip-card-01&orientation=portrait',
    isHot: true,
    slug: 'actor-midnight-date',
  },
  {
    id: 2,
    name: '李某某',
    title: '知名网红被曝偷税漏税千万',
    category: '网红大瓜',
    heat: '256.3万',
    summary: '税务部门已介入调查，该网红名下多家公司存在异常资金流动。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20stylish%20Chinese%20internet%20celebrity%20in%20a%20dramatic%20moody%20setting%2C%20warm%20golden%20lighting%20with%20deep%20shadows%2C%20film%20grain%20texture%2C%20editorial%20photography%20style%2C%20luxurious%20but%20mysterious%20atmosphere%2C%20simple%20dark%20background%20with%20subtle%20bokeh%20effects%2C%20high%20contrast%20warm%20tones&width=600&height=800&seq=gossip-card-02&orientation=portrait',
    isHot: true,
    slug: 'influencer-tax-evasion',
  },
  {
    id: 3,
    name: '王某某',
    title: '选秀冠军疑似学历造假',
    category: '明星黑料',
    heat: '89.7万',
    summary: '网友扒出其学历信息与公开资料不符，校方暂未做出回应。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20stylish%20Chinese%20talent%20show%20contestant%20in%20dramatic%20lighting%2C%20moody%20atmosphere%20with%20warm%20amber%20tones%2C%20soft%20film%20grain%20texture%2C%20editorial%20photography%20style%2C%20dark%20background%20with%20subtle%20spotlight%20effects%2C%20mysterious%20and%20glamorous%20vibe&width=600&height=800&seq=gossip-card-03&orientation=portrait',
    isHot: false,
    slug: 'talent-show-fake-degree',
  },
  {
    id: 4,
    name: '赵某某',
    title: '顶流艺人片场耍大牌惹众怒',
    category: '明星黑料',
    heat: '312.1万',
    summary: '多名剧组工作人员匿名爆料该艺人在片场的种种不当行为。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20stylish%20Chinese%20top%20celebrity%20in%20dramatic%20moody%20lighting%2C%20warm%20golden%20spotlights%2C%20film%20grain%20texture%2C%20editorial%20photography%20style%20with%20deep%20shadows%2C%20luxurious%20atmosphere%2C%20simple%20dark%20background%20with%20subtle%20light%20leaks&width=600&height=800&seq=gossip-card-04&orientation=portrait',
    isHot: true,
    slug: 'top-star-diva-behavior',
  },
  {
    id: 5,
    name: '刘某某',
    title: '女星豪门婚变内幕曝光',
    category: '娱乐圈八卦',
    heat: '198.2万',
    summary: '知情人透露两人已分居半年，财产分割问题成焦点。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20an%20elegant%20Chinese%20actress%20in%20dramatic%20lighting%2C%20moody%20warm%20atmosphere%2C%20film%20grain%20texture%2C%20editorial%20photography%20style%2C%20mysterious%20and%20emotional%20vibe%2C%20simple%20dark%20background%20with%20subtle%20bokeh&width=600&height=800&seq=gossip-card-05&orientation=portrait',
    isHot: false,
    slug: 'actress-divorce-scandal',
  },
  {
    id: 6,
    name: '陈某某',
    title: '带货主播售假被立案调查',
    category: '网红大瓜',
    heat: '445.6万',
    summary: '消费者投诉后监管部门介入，该主播直播间已暂停直播。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20stylish%20Chinese%20livestreamer%20in%20dramatic%20moody%20lighting%2C%20warm%20amber%20tones%2C%20film%20grain%20texture%2C%20editorial%20photography%20style%20with%20deep%20shadows%2C%20simple%20dark%20background%20with%20subtle%20spotlights&width=600&height=800&seq=gossip-card-06&orientation=portrait',
    isHot: true,
    slug: 'livestreamer-fake-goods',
  },
];

export const featureItems = [
  {
    icon: 'ri-flashlight-line',
    title: '实时爆料',
    description: '24小时不间断监控全网热点，第一时间推送最新明星黑料和娱乐圈大瓜，让你永远走在吃瓜第一线。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '深度起底',
    description: '专业团队深挖事件真相，多维度交叉验证信息来源，确保每一条爆料都经得起时间考验。',
  },
  {
    icon: 'ri-group-line',
    title: '吃瓜社区',
    description: '百万吃瓜群众在线互动，热门话题实时讨论，一起分享观点、交流看法，吃瓜更有趣。',
  },
];

export const navCategories = [
  { name: '明星黑料', slug: 'star-scandal', icon: 'ri-star-line' },
  { name: '网红大瓜', slug: 'influencer-gossip', icon: 'ri-user-smile-line' },
  { name: '娱乐圈八卦', slug: 'entertainment-gossip', icon: 'ri-chat-smile-2-line' },
  { name: '独家爆料', slug: 'exclusive-news', icon: 'ri-spy-line' },
];

export const footerLinks = {
  explore: [
    { name: '明星黑料', href: '/category/star-scandal' },
    { name: '网红大瓜', href: '/category/influencer-gossip' },
    { name: '娱乐圈八卦', href: '/category/entertainment-gossip' },
    { name: '独家爆料', href: '/category/exclusive-news' },
  ],
  about: [
    { name: '关于我们', href: '/about' },
    { name: '联系方式', href: '/about#contact' },
    { name: '用户协议', href: '#' },
    { name: '隐私政策', href: '#' },
  ],
};

export const siteInfo = {
  name: '51黑料吃瓜网',
  tagline: '汇聚全网海量网红明星黑料、娱乐圈八卦与独家爆料资源，深度起底热门事件真相。24小时不打烊实时推送最新大瓜，吃瓜群众速来围观！',
  phone: '400-888-8888',
  email: 'contact@51heiliaochigua.com',
  address: '北京市朝阳区星光大道88号传媒大厦15层',
  social: {
    weibo: '#',
    wechat: '#',
    douyin: '#',
    xiaohongshu: '#',
  },
};

export const heroStats = [
  { label: '累计爆料', value: '128,560+' },
  { label: '吃瓜群众', value: '890万+' },
  { label: '今日更新', value: '356条' },
];